import { render, staticRenderFns } from "./commonTab.vue?vue&type=template&id=79a3a8d2&scoped=true"
import script from "./commonTab.vue?vue&type=script&lang=js"
export * from "./commonTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a3a8d2",
  null
  
)

export default component.exports